var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.429,
    height: 9.393,
    viewBox: "0 0 16.429 9.393",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#45338c;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-648,1177.286c.373-.132.633-.224.892-.317.027-.01.059-.049.073-.042a2.808,2.808,0,0,1,.471.236c.375.27.989.275,1.01.949a1.723,1.723,0,0,0,.22.724.432.432,0,0,0,.393.115,7.62,7.62,0,0,0,1.7-1.029c.407-.262.869-.437,1.292-.676.384-.217.74-.481,1.122-.7.482-.277.983-.521,1.466-.8.515-.292,1.011-.62,1.532-.9.427-.232.873-.431,1.32-.623.408-.175.831-.317,1.246-.476.445-.171.882-.37,1.337-.511s.929-.227,1.4-.334a.244.244,0,0,1,.132.008c.458.165.33.683.568.99.038.05-.169.337-.307.467a8.77,8.77,0,0,1-3.141,1.821.432.432,0,0,0-.177.11,8.522,8.522,0,0,1-2.1,1.41c-.6.378-1.156.826-1.743,1.226-.3.206-.635.367-.945.561-.649.407-1.269.868-1.944,1.228a10.6,10.6,0,0,1-3.83,1.559,1.924,1.924,0,0,1-1.153-.28,4.984,4.984,0,0,1-.986-1.019.634.634,0,0,1-.1-.405q.037-.92.109-1.837C-648.107,1178.221-648.046,1177.7-648,1177.286Z",
    transform: "translate(648.257 -1172.898)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick8);
export default __webpack_public_path__ + "static/media/tick-8.fbd9d0631f8a19e09568eb5050d55221.svg";
export { ForwardRef as ReactComponent };